
// File: src/components/RSVPModal.jsx
import React from 'react';
import "./RSVPModal.scss";
/**
 * @param {{ isOpen: boolean; onClose: () => void; user: { src: string; alt: string } }} props
 */
const RSVPModal = ({ isOpen, onClose, user, onRSVP }) => {
  if (!isOpen) return null;
  const { uid, imageUrl, name } = user;
   // Generate a consistent color per user ID  
   const getRandomColor = (id) => {
    let hash = 0;
    for (let char of id) {
      hash = char.charCodeAt(0) + ((hash << 5) - hash);
    }
    const hue = Math.abs(hash) % 360;
    return `hsl(${hue}, 70%, 50%)`;
  };

  // Get initial letter from alt (assumed name)
  const getInitial = (name) => (name ? name.charAt(0).toUpperCase() : '');

  const hasImage = imageUrl && imageUrl.trim() !== '';

  return (
    <div className="rsvp-modal-overlay">
      <div className="rsvp-modal">
        <button className="close-button" onClick={onClose} aria-label="Close">
         x
        </button>
        <div className="avatar-container">
         {hasImage ? <img src={user.imageUrl} alt={user.alt} className="avatar-large" /> : 
         <div
         className="avatar-img placeholder"
         style={{ backgroundColor: getRandomColor(uid) }}
       >
         <span className="initial">{getInitial(name)}</span>
       </div>
         
        }
        </div>
        <h3 className="rsvp-title">RSVP to interact with {user.alt}!</h3>
        <button className="rsvp-button" onClick={onRSVP}>RSVP</button>
      </div>
    </div>
  );
};

export default RSVPModal;